import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter, CustomInput, Col, Card
} from 'reactstrap';
import short from 'short-uuid';
import { gAPI_NudgesButtonList } from '../../../../../../constants/APIs';

import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import LanguageTabs from '../../../propinfo/components/LanguageTabs/LanguageTabs';
const EyeCatcherCode1 = `integration-${short.generate()}-eyeCatcher`;

export function NudgesForm({
    visible,
    toggle,
    formLabel,
    submit,
    nudgeData,
    nudgeIndex,
    messengerItems,
    locale,
    integrationLanguages,
    integrationId
}) {
    //console.log(nudgeData);
    const [selectedLang, setSelectedLang] = useState(locale);
    const [updateEyeCatcherNudgesData, setUpdateEyeCatcherNudgesData] = useState({});
    const [inputFields, setInputFields] = useState([]);
    const [delayInMilliseconds, setDelayInMilliseconds] = useState('');
    const [delayInMillisecondsInMobile, setDelayInMillisecondsInMobile] = useState('');
    const [disabledInDesktop, setDisabledInDesktop] = useState(false);
    const [disabledInMobile, setDisabledInMobile] = useState(false);
    const [buttons, setButtons] = useState([]);
    const [otherLanguages, setOtherLanguages] = useState([]);
    const LoadNudges = (language) => {
        setInputFields([]);
        setButtons([]);
        setOtherLanguages([]);
        setUpdateEyeCatcherNudgesData({});
        var lang = language;
        if (language === "en") { lang = "en-US"; }
        if (language === "zh-TW") { lang = "hk"; }

        AxiosAPI({
            methhod: 'get',
            url: `${gAPI_NudgesButtonList}/${integrationId}?group_id=${getGroupID()}&lang=${lang}`,
        }).then((res) => {
            var nudges = res.data.channelDetails.initiationRuleset[0].nudges[nudgeIndex];

            if (lang !== "en-US" && nudges.eyeCatcher === null) {
                setUpdateEyeCatcherNudgesData({
                    GroupId: getGroupID(),
                    Code: EyeCatcherCode1,
                    Language: lang,
                    Channel: 'WebsiteDirectLine',
                    Default: [],
                    Overrides: {}
                });
                if (nudges.otherLanguages !== null) {
                    var other = [...nudges.otherLanguages, { code: EyeCatcherCode1, languageCode: lang }];
                    setOtherLanguages(other);
                }
                if (nudges.buttons != null && nudges.buttons.length > 0) {
                    setButtons(nudges.buttons);
                }
            } else {
                setUpdateEyeCatcherNudgesData({
                    GroupId: getGroupID(),
                    Code: nudges.eyeCatcher.query.code,
                    Language: lang,
                    Channel: 'WebsiteDirectLine',
                    Default: nudges.eyeCatcher.response.messages,
                    Overrides: {}
                });
                if (lang !== "en-US") {
                    if (nudges.otherLanguages.length > 0) {
                        if (nudges.otherLanguages.filter((o) => o.code === nudges.eyeCatcher.query.code && o.languageCode === lang).length > 0) {
                            nudges.otherLanguages.filter((o) => o.code === nudges.eyeCatcher.query.code && o.languageCode === lang)
                                .map((elem) => {
                                    setInputFields(elem.buttons);
                                });
                            setOtherLanguages(nudges.otherLanguages);
                        }
                        else {
                            var other = [...nudges.otherLanguages, { code: nudges.eyeCatcher.query.code, languageCode: lang, buttons: [] }];
                            setOtherLanguages(other);

                        }
                    } else {
                        var other = [...nudges.otherLanguages, { code: nudges.eyeCatcher.query.code, languageCode: lang, buttons: [] }];
                        setOtherLanguages(other);

                    }
                    if (nudges.buttons != null && nudges.buttons.length > 0) {
                        setButtons(nudges.buttons);
                    }
                } else {
                    if (nudges.buttons != null && nudges.buttons.length > 0) {
                        setInputFields(nudges.buttons);
                        setButtons(nudges.buttons);
                    }
                    if (nudges.otherLanguages !== null && nudges.otherLanguages.length > 0) {
                        setOtherLanguages(nudges.otherLanguages);
                    }
                }
            }

            if (nudges.delayInMilliseconds != null) {
                setDelayInMilliseconds(nudges.delayInMilliseconds / 1000)
            }
            if (nudges.delayInMillisecondsInMobile != null) {
                setDelayInMillisecondsInMobile(nudges.delayInMillisecondsInMobile / 1000)
            }
            if (nudges.disabledInDesktop != null) {
                setDisabledInDesktop(!nudges.disabledInDesktop);
            }
            if (nudges.disabledInMobile != null) {
                setDisabledInMobile(!nudges.disabledInMobile);
            }
        });

    }
    useEffect(() => {
        LoadNudges(locale);
    }, [locale]);

    const handleChangeEyeCatcher = e => {
        const arr = [e.target.value];
        setUpdateEyeCatcherNudgesData({
            ...updateEyeCatcherNudgesData,
            Default: arr,
        });
    };
    const handleSubmit = () => {
        var other = [];
        var button = buttons;
        var lang = selectedLang;
        if (selectedLang === "zh-TW") { lang = "hk"; }
        if (lang !== "en") {
            otherLanguages.map((lan) => {
                if (lan.languageCode === lang) {
                    other.push({
                        code: lan.code,
                        buttons: inputFields,
                        languageCode: lan.languageCode
                    })
                } else {
                    other.push({
                        code: lan.code,
                        buttons: lan.buttons,
                        languageCode: lan.languageCode
                    })
                }
            })
        }
        else {
            other = otherLanguages;
            button = inputFields;
        }
        let nudgeButtonBody = {
            nudgeIndex: nudgeIndex,
            delayInMilliseconds: delayInMilliseconds * 1000,
            delayInMillisecondsInMobile: delayInMillisecondsInMobile * 1000,
            disabledInDesktop: !disabledInDesktop,
            disabledInMobile: !disabledInMobile,
            buttons: button,
            otherLanguages: other,
            languageCode: lang
        }

        submit(updateEyeCatcherNudgesData, nudgeButtonBody);
    };

    const handleAddFields = () => {
        const values = [...inputFields];
        values.push({
            text: '',
            value: '',
            option: 'None'
        });
        setInputFields(values);
    };

    const handleRemoveFields = index => {
        const values = [...inputFields];
        values.splice(index, 1);
        setInputFields(values);
    };

    const handleInputChange = (index, event) => {
        const values = [...inputFields];
        if (event.target.name === 'text') {
            values[index].text = event.target.value;
        }
        else if (event.target.name === 'value') {
            values[index].value = event.target.value;
        }
        else if (event.target.name === 'option') {
            values[index].option = event.target.value;
            if (event.target.value === "SendToChatbot") {
                values[index].value = "Message to send";
            }
            else {
                values[index].value = "";
            }
        }

        setInputFields(values);
    };
    const handleInputChangeDelay = (event) => {
        if (event.target.name === "delayInMilliseconds") {
            setDelayInMilliseconds(event.target.value);
        }
        else {
            setDelayInMillisecondsInMobile(event.target.value);
        }
    };
    const handleEnabledChange = (event) => {
        // console.log(event.target.name, event.target.checked);
        if (event.target.name === "disabledInDesktop") {
            setDisabledInDesktop(event.target.checked);
        }
        else {
            setDisabledInMobile(event.target.checked);
        }
    }
    const SwitchLanguage = (e) => {
        LoadNudges(e);
        setSelectedLang(e);
    }

    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle} size="lg" backdrop="static">
                <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
                <ModalBody>
                    <Card className="p-4">
                        <Colxx xxs="12" className="px-0">
                            {/* <pre>{JSON.stringify(updateEyeCatcherNudgesData, null, 2)}</pre> */}
                            <Row className="text-left mb-4">
                                <LanguageTabs
                                    integrationLanguages={integrationLanguages}
                                    selectedTab={selectedLang}
                                    setLanguage={(e) => SwitchLanguage(e)}
                                ></LanguageTabs>
                                {updateEyeCatcherNudgesData.Default && (
                                    <Colxx sm={12} className="mt-3">
                                        <h6>Eye Catcher</h6>
                                        <Input
                                            type="text"
                                            value={updateEyeCatcherNudgesData.Default[0]}
                                            onChange={handleChangeEyeCatcher}
                                            name="name"
                                        />
                                    </Colxx>
                                )}
                            </Row>
                            <Row className="text-left mb-4">
                                <Colxx xxs="12">
                                    <h6>Desktop</h6>
                                    <Separator className="mb-2" />
                                </Colxx>
                                <Colxx sm={4}>
                                    <Label>Delay in Seconds</Label>
                                    <Input
                                        type="number"
                                        value={delayInMilliseconds
                                            ? delayInMilliseconds
                                            : null}
                                        onChange={event => handleInputChangeDelay(event)}
                                        name="delayInMilliseconds"
                                    />
                                </Colxx>
                                <Colxx sm={4} className="mt-2">
                                    <CustomInput
                                        className="mt-4"
                                        id="lan"
                                        type="checkbox"
                                        label="Enabled (Desktop)"
                                        checked={disabledInDesktop}
                                        name="disabledInDesktop"
                                        onChange={handleEnabledChange}
                                    />
                                </Colxx>
                            </Row>
                            <Row className="text-left mb-4">
                                <Colxx xxs="12">
                                    <h6>Mobile</h6>
                                    <Separator className="mb-2" />
                                </Colxx>
                                <Colxx sm={4}>
                                    <Label>Delay in Seconds</Label>
                                    <Input
                                        type="number"
                                        value={delayInMillisecondsInMobile
                                            ? delayInMillisecondsInMobile
                                            : null}
                                        onChange={event => handleInputChangeDelay(event)}
                                        name="delayInMillisecondsInMobile"
                                    />
                                </Colxx>
                                <Colxx sm={4} className="mt-2">
                                    <CustomInput
                                        className="mt-4"
                                        id="lan1"
                                        type="checkbox"
                                        label="Enabled (Mobile)"
                                        checked={disabledInMobile}
                                        name="disabledInMobile"
                                        onChange={handleEnabledChange}
                                    />
                                </Colxx>
                            </Row>
                            <Row className="text-left">
                                <Colxx sm={12}>
                                    <h6>Buttons</h6>
                                    <Separator className="" />
                                </Colxx>
                                {inputFields.map((nudge, index) => (
                                    <div key={index} className="d-flex mt-3">
                                        <Colxx sm={3}>
                                            <Label>Text</Label>
                                            <Input
                                                type="text"
                                                name="text"
                                                value={nudge.text}
                                                onChange={event => handleInputChange(index, event)}
                                            />
                                        </Colxx>
                                        <Colxx sm={4}>
                                            <Label>Option</Label>
                                            <Input
                                                type="select"
                                                name="option"
                                                value={nudge.option}
                                                onChange={event => handleInputChange(index, event)}
                                            >
                                                <option value={"None"}>Select</option>
                                                <option value={"OpenMenuItem"}>Open Menu Item</option>
                                                <option value={"SendToChatbot"}>Send to Chatbot</option>
                                                <option value={"OpenURL"}>Open URL</option>
                                            </Input>
                                        </Colxx>
                                        <Colxx sm={4}>
                                            <Label>Value</Label>
                                            {nudge.option === "OpenMenuItem" ? (
                                                <Fragment>
                                                    <Input
                                                        type="select"
                                                        name="value"
                                                        value={nudge.value}
                                                        onChange={event => handleInputChange(index, event)}
                                                    >
                                                        <option value={""}>Select</option>
                                                        {messengerItems.map((item, index) => (
                                                            <option value={item.id}>{item.title}</option>
                                                        ))}
                                                    </Input>
                                                </Fragment>
                                            ) : (
                                                <Input
                                                    type="text"
                                                    name="value"
                                                    value={nudge.value}
                                                    onChange={event => handleInputChange(index, event)}
                                                />
                                            )}
                                        </Colxx>
                                        <Colxx sm={1}>
                                            <Label>Remove</Label>
                                            <div>
                                                <Button
                                                    onClick={() => handleRemoveFields(index)}
                                                    color="secondary"
                                                    size="xs"
                                                    outline
                                                    className="mt-1"
                                                >
                                                    X
                                                </Button>
                                            </div>
                                        </Colxx>
                                    </div>
                                ))}
                            </Row>
                            <Button
                                onClick={handleAddFields}
                                color="primary"
                                size="xs"
                                outline
                                className="mt-3"
                            >
                                + Add Button
                            </Button>
                        </Colxx>
                    </Card>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" size='xs' onClick={handleSubmit}>Update</Button>
                    <Button color="secondary" size='xs' onClick={toggle}>Cancel</Button>
                </ModalFooter>
            </Modal>
        </Fragment >
    );
}